
function productColumns(handleEdit, handleDelete, isAdmin) {
  return [
    {
      Header: "Product Name",
      accessor: "name",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "stock",
      accessor: "stock",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Buying price",
      accessor: "buying_price",
      disableFilters: true,
      filterable: false,
    },
    {
      Header: "Selling price",
      accessor: "selling_price",
      disableFilters: true,
      filterable: false,
    },
    ...(isAdmin && (handleEdit || handleDelete)
      ? [
          {
            Header: "Actions",
            accessor: "actions",
            disableFilters: true,
            filterable: false,

            Cell: ({ row }) => (
              <div className="d-flex gap-2">
                {handleEdit && (
                  <button
                    onClick={() => handleEdit(row.original)}
                    className="btn btn-sm btn-primary"
                  >
                    Edit
                  </button>
                )}
                {handleDelete && (
                  <button
                    onClick={() => handleDelete(row.original)}
                    className="btn btn-sm btn-danger"
                  >
                    Delete
                  </button>
                )}
              </div>
            ),
          },
        ]
      : []),
  ];
}

export default productColumns;
